import MobileHomeNotice from './MobileHomeNotice';

export default MobileHomeNotice;
